import { usePostBySlug } from '@frontend/libs/hooks/usePost'
import ErrorBoundary from '@shared/ErrorBoundary'
import NotFound from '@shared/screens/NotFound'
import { __ } from '@wordpress/i18n'
import { useLayoutEffect } from 'react'
import { useErrorBoundary } from 'react-error-boundary'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

import { SignInForm, SignUpForm } from '../../features/authentication'
import useAuth from '../../hooks/useAuth'

const AuthContent = () => {
  const { showBoundary } = useErrorBoundary()
  const { data: post, error, isLoading } = usePostBySlug('my-account')

  if (isLoading) return <span>Loading...</span>

  if (error) {
    if ((error as { code?: string })?.code === 'not_found') {
      return <NotFound />
    }
    toast.error('Failed to fetch post')
    showBoundary(error)
  }

  if (!post) {
    showBoundary('No response data')
    return <></>
  }

  document.title = post.meta.title

  const styleTag = document.getElementById('core-block-supports-inline-css')

  if (styleTag) {
    styleTag.innerHTML = post.styles
  } else {
    const style = document.createElement('style')
    style.id = 'core-block-supports-inline-css'
    document.head.appendChild(style)
    style.innerHTML = post.styles
  }

  return <></>
}

function Content() {
  const navigate = useNavigate()
  const { isLoggedIn } = useAuth()

  useLayoutEffect(() => {
    if (isLoggedIn) {
      navigate('/my-account/edit-account')
    }
  }, [isLoggedIn, navigate])

  return (
    <div className="my-12">
      <div className="mx-auto max-w-screen-xl">
        {!isLoggedIn && (
          <div className="flex min-h-[54vh] items-center justify-center">
            <div className="grid grid-cols-1 divide-y md:grid-cols-2 md:divide-x md:divide-y-0 [&>*]:py-16 md:[&>*]:px-16 md:[&>*]:py-0">
              <div>
                <SignInForm />
              </div>
              <div>
                <SignUpForm />
              </div>
            </div>
          </div>
        )}
        <AuthContent />
      </div>
    </div>
  )
}

export function MyAccount() {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default MyAccount
